import React from 'react'
import './index.scss'

const DotsLoader = () => {
  return (
    <div className="dot-pulse" />
  )
}

export default DotsLoader